var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0C8.4375 0 8.75 0.3125 8.75 0.625V2.5H15V0.625C15 0.3125 15.2734 0 15.625 0C15.9375 0 16.25 0.3125 16.25 0.625V2.5H17.5C18.8672 2.5 20 3.63281 20 5V13.75C20 15.1562 18.8672 16.25 17.5 16.25H6.25C4.84375 16.25 3.75 15.1562 3.75 13.75V5C3.75 3.63281 4.84375 2.5 6.25 2.5H7.5V0.625C7.5 0.3125 7.77344 0 8.125 0ZM5 5V6.25H18.75V5C18.75 4.33594 18.1641 3.75 17.5 3.75H6.25C5.54688 3.75 5 4.33594 5 5ZM5 7.5V13.75C5 14.4531 5.54688 15 6.25 15H17.5C18.1641 15 18.75 14.4531 18.75 13.75V7.5H5ZM1.25 15C1.25 17.0703 2.89062 18.75 5 18.75H14.375C14.6875 18.75 15 19.0625 15 19.375C15 19.7266 14.6875 20 14.375 20H5C2.22656 20 0 17.7734 0 15V8.125C0 7.8125 0.273438 7.5 0.625 7.5C0.9375 7.5 1.25 7.8125 1.25 8.125V15Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermBill);
export default __webpack_public_path__ + "static/media/term-bill.1b1739f68f8b2988b556bf1346e2b4a3.svg";
export { ForwardRef as ReactComponent };